import React from 'react';
import classNames from 'classnames';
import iconPlay from '../../../images/icon-play.svg';

const FeaturedOrgs = (props) => {

    // const color = CONGRESS_COMMUNITIES.filter(congress => congress.alt_name == category);
    const { id, company, city, state, currentPage, mission, story, index, color, fullname, is_featured, featuredOrgs } = props;

    const featuredColor = color.color;

    // eslint-disable-next-line consistent-return
    function hasVideo(orgID) {
      orgID += ''; // convert number to string
      const featuredOrgsArray = featuredOrgs !== null && featuredOrgs; // assign array
      if (featuredOrgsArray.length) { // once array has data check if org has video
          for (let i = 0; i < featuredOrgsArray.length; i++) {
              if (orgID === featuredOrgsArray[i].properties.id &&
                  featuredOrgsArray[i].properties.story.youtube_id !== null &&
                  featuredOrgsArray[i].properties.story.youtube_id !== '') {
                  return true;
              }
          }
      }
    }
    
    return (

        <li>
            {/* <a
                alt={`Search Result: ${company}`}
                className="result featured"
                href={`${process.env.PUBLIC_URL}/organization/?search=${id}`}
            > */}
                <article
                  data-is-featured={`${is_featured === '1'}`}
                >
                    <div className="category-span">
                      <span className={`category ${featuredColor}`}>{fullname}</span>
                    </div>
                    <div className="copy">
                        <h2> {currentPage === 1 && `${index + 1}. `}
                            {index < 9
                                ? currentPage > 1 && `${currentPage - 1}${index + 1}. `
                                : currentPage > 1 && `${currentPage}${0}. `
                            }
                            {company}
                        </h2>
                        <em>{city}, {state}</em>
                        {/* <div className="mission">
                            {story && story.preview ? story.preview.substring(0, 200) : mission.substring(0, 200)}
                            {story && story.preview.length > 200 ? (
                                    <span>&hellip;</span>
                                ) :
                                (!story && mission.length > 200 && (
                                    <span>&hellip;</span>
                                ))
                            }
                        </div> */}
                    </div>
                    {/* <div className="media">
                        {is_featured === '1' && (
                            <div className={ classNames('img', { video: hasVideo(id) }) }>
                                <img
                                    alt=""
                                    src={`${
                                        process.env.PUBLIC_URL
                                    }/images/org/featured/${
                                        id
                                    }.jpg`}
                                    title={`Featured Organization: ${
                                        company
                                    }`}
                                />
                                {hasVideo(id) && (
                                  <img src={iconPlay} alt="View video" className="play"/>
                                )}                                
                            </div>
                        )}
                    </div> */}
                </article>
            {/* </a> */}
        </li>

    );
};

export default FeaturedOrgs;

